module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAATVJREFUOE+tlDFKBEEQRd/XzFRQzAT1GoIHEEEEVzyAkegRNNJgMVgQzAVRULzCgmAmmDumsoYKIgb6pYdZmV2md6ZlO+z+9bq66neJMS+Nmccf0PYssAxMJF7yA9xJ6oW4MvAJWEyE9eWZpKVhoIGWpKsUqO1N4FJSnlw5wyjQ9lbQSroYvqwRsKjnI7Ar6dp2BkwD85LeytCmwFtgDXgBtoEu8AUcSTpMAfa1oXMt4Az4Bt6Bc+CgBOtI2qvLsAPcA6+SurZ3CuhxAVsFJgvog6SsDjjQZdvBk23gVNJzVfeTgE3sUweMMUKXg8UWYoIqH34AU5GA/eJLnkTOPyXlsWVjbwDr5b0mTy40N8GvA8CE4JHS6PiyHaZHmEBVqydprupgFHAFmIkAc58mAf9bgrFP7F/LFJYVIhqD+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newscategory3.png
// module id = mz/x
// module chunks = 4